import { createSelector } from 'reselect';

const featureFlags = state => state.modules.featureFlags;

export const getFeatureFlagsStatus = createSelector(
  featureFlags,
  state => state.featureFlagsStatus,
);

export const getFeatureFlagsData = createSelector(
  featureFlags,
  state => state.featureFlagsData,
);
